import { render } from "./ViewMediaPress.vue?vue&type=template&id=15a571dc&scoped=true"
import script from "./ViewMediaPress.vue?vue&type=script&lang=js"
export * from "./ViewMediaPress.vue?vue&type=script&lang=js"

import "./ViewMediaPress.vue?vue&type=style&index=0&id=15a571dc&scoped=true&lang=css"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15a571dc"]])

export default __exports__